export const purchaseOrderStatus = {
  Submitted: 5,
  AwaitingConfirmation: 10,
  SupplierConfirmed: 15,
  PendingShipment: 17,
  ShipmentRequested: 30,
  ShipmentBooked: 32,
  ShipmentConfirmed: 33
};